import React from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { useI18n } from '../../i18n'
import { NODES } from '../../config/graphEntities'

/** Layout для Узлов: табы узлов (как у агентов), по умолчанию первый узел. */
export default function SettingsNodesLayout() {
  const { t } = useI18n()

  return (
    <div className="settings-agents-tabs-layout settings-nodes-tabs-layout">
      <div className="settings-agents-tabs-row">
        <nav className="settings-agents-tabs">
          {NODES.map((node) => (
            <NavLink
              key={node.key}
              to={node.key}
              className={({ isActive }) => `settings-tab ${isActive ? 'active' : ''}`}
            >
              {node.labelKey ? t(node.labelKey) : node.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="settings-agents-content">
        <Outlet />
      </div>
    </div>
  )
}
